export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-7c-7d692fca30db1ba5ff37c7c22ff862b4.webp";